import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import Modal from 'components/Modal';
import Form from 'components/Form/Form';
import useModal from 'hooks/useModal';
import useConfig from 'hooks/useConfig';
import useSession from 'hooks/useSession';

function ModalAddUpdateSession(props) {
	const {t} = useTranslation();
	let {
		forceOpen = false,
		setForceOpenOpen,
		id = false
	} = props;

	const {
		isShowing,
		hide,
		show
	} = useModal();

	const {
		user
	} = useConfig();

	const closeModal = () => {
		if (typeof setForceOpenOpen === 'function') {
			setForceOpenOpen(false);
		}
		hide();
	}

	useEffect(() => {
		if (forceOpen && !isShowing) {
			return show();
		}
		if (!forceOpen && isShowing) {
			hide();
		}
	}, [forceOpen, show, hide, isShowing]);

	return (
		<Modal
			isShowing={isShowing}
			hide={closeModal}
			title={t('ModalAddUpdateSession.title')}
			closeButton={forceOpen}
			className="ModalAddUpdateSession"
		>
			<Form
				id={id}
				hook={useSession}
				inputs={[
					{
						label: t('Session.form.name'),
						name: 'name',
						required: true
					},
					{
						name: 'user',
						required: true,
						type: 'hidden',
						value: user['@id']
					}
				]}
			/>
		</Modal>
	);
}

export default ModalAddUpdateSession;
